<ion-header>
    <ion-toolbar>

        <!-- <ion-title mode="ios" role="heading">{{ 'TERMS_HEADER' | translate}}</ion-title> -->

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content fullscreen="true">
    <ion-slides pager="false" [options]="slideOpts" #slides>
        <ion-slide [attr.aria-hidden]="slideIndex !== 0">
            <div class="slide-container">
                <p>{{ 'STOP_DEFINITION_STOP_DEFINITION' | translate }}</p>
                <p role="heading" aria-level="3">{{ 'STOP_DEFINITION_STOP_EXAMPLES' | translate }}</p>
                <ul>
                    <li>{{ 'STOP_DEFINITION_STOP_EXAMPLE_1' | translate }}</li>
                    <li>{{ 'STOP_DEFINITION_STOP_EXAMPLE_2' | translate }}</li>
                    <li>{{ 'STOP_DEFINITION_STOP_EXAMPLE_3' | translate }}</li>
                    <li>{{ 'STOP_DEFINITION_STOP_EXAMPLE_4' | translate }}</li>
                </ul>
            </div>
        </ion-slide>
        <ion-slide [attr.aria-hidden]="slideIndex !== 1">
            <div class="slide-container">
                <h4 [innerHTML]="'STOP_DEFINITION_WHAT_IS_NOT_A_STOP' | translate"></h4>
                <ul>
                    <li [innerHTML]="'STOP_DEFINITION_NOT_STOP_EXAMPLE_1' | translate"></li>
                    <li [innerHTML]="'STOP_DEFINITION_NOT_STOP_EXAMPLE_2' | translate"></li>
                    <li [innerHTML]="'STOP_DEFINITION_NOT_STOP_EXAMPLE_3' | translate"></li>
                </ul>
            </div>
        </ion-slide>
        <ion-slide [attr.aria-hidden]="slideIndex !== 2">
            <div class="slide-container">
                <h4 [innerHTML]="'STOP_DEFINITION_CHANGED_VEHICLES' | translate"></h4>
                <p [innerHTML]="'STOP_DEFINITION_CHANGED_EXAMPLE_1' | translate"></p>
            </div>
        </ion-slide>
        <ion-slide [attr.aria-hidden]="slideIndex !== 3">
            <div class="slide-container">
                <h4 [innerHTML]="'STOP_DEFINITION_IF_CHANGE_PASSENGERS' | translate"></h4>
                <p [innerHTML]="'STOP_DEFINITION_PASSENGERS_PROMPT' | translate"></p>
                <p role="heading" aria-level="3">{{ 'STOP_DEFINITION_PASSENGERS_EXAMPLES' | translate }}</p>
                <ul>
                    <li [innerHTML]="'STOP_DEFINITION_PASSENGERS_EXAMPLE_1' | translate"></li>
                    <li [innerHTML]="'STOP_DEFINITION_PASSENGERS_EXAMPLE_2' | translate"></li>
                    <li [innerHTML]="'STOP_DEFINITION_PASSENGERS_EXAMPLE_3' | translate"></li>
                </ul>

            </div>
        </ion-slide>

    </ion-slides>
    <ion-row class="hide-for-small-screen container-md">
        <ion-col>
            <ion-button
                expand="block"
                class="emphasized-button"
                [disabled]="slideIndex === 0"
                (click)="slidePrev()"
                [innerHTML]="'BUTTON_PREVIOUS' | translate">
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button
                expand="block"
                class="emphasized-button"
                (click)="slideNext()">
                {{ (slideIndex !== 3 ? 'BUTTON_NEXT' : 'BUTTON_DONE') | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-content>
<ion-footer class="hide-for-large-screen">
    <ion-row>
        <ion-col>
            <ion-button
                expand="full"
                color="light"
                (click)="slidePrev()"
                [disabled]="slideIndex === 0"
                [innerHTML]="'BUTTON_PREVIOUS' | translate"></ion-button>
        </ion-col>
        <ion-col>
            <ion-button
                expand="full"
                color="light"
                (click)="slideNext()">
                {{ (slideIndex !== 3 ? 'BUTTON_NEXT' : 'BUTTON_DONE') | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>
